import { render, staticRenderFns } from "./Yhdb.vue?vue&type=template&id=63df756e&scoped=true"
import script from "./Yhdb.vue?vue&type=script&lang=js"
export * from "./Yhdb.vue?vue&type=script&lang=js"
import style0 from "./Yhdb.vue?vue&type=style&index=0&id=63df756e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df756e",
  null
  
)

export default component.exports